var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCake = function SvgCake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cake_svg__a",
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cake_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FB3C6C",
    d: "M4.725 21c-.2 0-.37-.075-.512-.225a.77.77 0 0 1-.213-.55v-4.15c0-.45.158-.833.475-1.15.317-.317.7-.475 1.15-.475h12.75c.45 0 .833.158 1.15.475.317.317.475.7.475 1.15v4.15c0 .217-.075.4-.225.55a.748.748 0 0 1-.55.225h-14.5ZM6 13.45V9.7c0-.45.158-.833.475-1.15.317-.317.7-.475 1.15-.475H11.5V6.6c-.283-.2-.52-.417-.712-.65a1.294 1.294 0 0 1-.288-.85c0-.2.038-.388.113-.563.075-.175.187-.337.337-.487L12 3l1.05 1.05c.15.15.262.312.337.487.075.175.113.363.113.563 0 .333-.096.617-.287.85-.192.233-.43.45-.713.65v1.475h3.875c.45 0 .833.158 1.15.475.317.317.475.7.475 1.15v3.75H6Z"
  }))));
};
export default SvgCake;